import { RefObject } from 'react';
import { CommonFormField } from '../../../../components/Form/CommonFormField';
import {
  MultiSelectAttributeInput,
  MultiSelectAttributeInputProps,
} from '../../../../components/HeadlessComponents/MultiSelectAttributeInput';

export type MultiSelectAttributeFieldProps = Omit<MultiSelectAttributeInputProps, 'error'> & {
  required?: boolean;
  error?: string;
  fieldRef?: RefObject<HTMLDivElement>;
};

/**
 * Layer B multi-select field wrapper. Same shape rationale as
 * `SelectAttributeField`.
 */
export const MultiSelectAttributeField = ({
  attribute,
  required,
  error,
  fieldRef,
  clearable = true,
  ...inputProps
}: MultiSelectAttributeFieldProps) => (
  <CommonFormField label={attribute.displayName} required={required} error={error} ref={fieldRef}>
    <MultiSelectAttributeInput
      attribute={attribute}
      {...inputProps}
      clearable={clearable}
      error={!!error}
    />
  </CommonFormField>
);
